import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import reportWebVitals from "./reportWebVitals";

const element = document.getElementById("rezzi_plugin");
if (element) {
  const module = element.dataset.module;
  const employee = element.dataset.employee;
  const defaultQuote = element.dataset.default_quote;
  const internalQuote = element.dataset.internal;
  const template = element.dataset.template;
  const result_url = element.dataset.result_url;

  ReactDOM.render(
    <React.StrictMode>
      <App
        module={module}
        defaultQuote={defaultQuote}
        internalQuote={internalQuote}
        template={template}
        result_url={result_url}
        employee={employee}
      />
    </React.StrictMode>,
    element
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
